<template>
    <div>
        <HeaderMenu></HeaderMenu>
        
    </div>
</template>
<script>

import HeaderMenu from '../HeaderMenu'


export default{
    data(){
        this.get_page_content();
        return {
            news_listing:null,
            hostname:this.$hostname,
            current_locale:this.$i18n_global.locale
        }
    },
    components:{
        HeaderMenu:HeaderMenu
    },
    methods:{
        async get_page_content() {
            var _self = this; 

            await this.$axios_global.post(_self.$hostname+'/api/news-insights-details',{
              slug:_self.$route.params.slug
            })
            .then((res) => {
                var response = res.data.data;
                _self.news_listing = response;
            })
            .catch((error) => {
                console.log(error.response.data.error);
                return false;  
            }) 
            return false; 
        },
        format_date(value){
            if (value) {
               return this.$moment_global(String(value)).format('YYYY-MM-DD')
            }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/News/NewsInsightsDetails.vue